import React from 'react';
import { connect } from 'react-redux';
import ProductPageComponent from './ProductPage.component';
import { getLinkType, getRules } from '../../reducers/feature.reducer';
import { EXTERNAL_NAMESPACE } from '../../constants';

export const mapStateToProps = (state, ownProps) => {
  const { pathname } = ownProps.location;
  const querystring = ownProps.location.search;
  const linkType = getLinkType({ state: state.feature, page: 'pip', tag: 'product_pod' });
  const { itemId } = ownProps.match.params;
  return {
    itemId,
    pathname,
    linkType,
    querystring,
    namespace: EXTERNAL_NAMESPACE
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    replace: ownProps.history.replace,
    push: ownProps.history.push
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPageComponent);
